<dialog-layout>
  <div content class="sm:flex sm:items-start">
    <div
      class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"
    >
      <svg width="800px" height="800px" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"
           enable-background="new 0 0 48 48">
        <circle fill="#4CAF50" cx="24" cy="24" r="21" />
        <polygon fill="#FFFFFF" points="34.6,14.6 21,28.2 15.4,22.6 12.6,25.4 21,33.8 37.4,17.4" />
      </svg>
    </div>
    <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
      <div
        class="text-base font-semibold leading-6 text-gray-900"
        id="modal-title"
      >
        {{ data.title }}
      </div>
      <div class="mt-2">
        <p class="text-sm text-gray-500">
          {{ data.description }}
        </p>
      </div>
    </div>
  </div>
  <div content-actions>
    <button mat-stroked-button
            class="success-button-color"

            (click)="buttonOne()"
    >
      {{ data.textFirstButton }}
    </button>


  </div>
</dialog-layout>
